var map = {
	"./background--1.jpg": 364,
	"./background--2.jpg": 365,
	"./background--3.jpg": 366,
	"./background--4.jpg": 367,
	"./background--5.jpg": 368,
	"./background--6.jpg": 369,
	"./icon-heart-fill.svg": 370,
	"./icon-heart-outline.svg": 371
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 363;